export default __webpack_public_path__ + "static/media/Approval.ab5a9086.svg";